import type { AuthSession } from '@app-types/api/auth'
import type { ColumnDescription } from '@app-types/analytics/column'

export const numberFormatter = new Intl.NumberFormat('ru-RU', {
  maximumFractionDigits: 2,
})

export const moneyFormatter = new Intl.NumberFormat('ru-RU', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 2,
})

export function asNumber(value: unknown): number | null
export function asNumber(value: unknown, def: number): number
export function asNumber(value: unknown, def: null): number | null
export function asNumber(value: unknown, def: number | null = null) {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value
  }

  if (typeof value === 'string' && value.trim() !== '') {
    const parsed = Number(value)
    return Number.isFinite(parsed) ? parsed : def
  }

  return def
}

export function formatValue(value: unknown, format: ColumnDescription['format']) {
  if (value === null || value === undefined || value === '') {
    return '—'
  }

  if (format === 'bool') {
    return value ? 'Да' : 'Нет'
  }

  const numericValue = asNumber(value)
  if (numericValue === null) {
    return String(value)
  }

  if (format === 'money' || format === 'price') {
    return moneyFormatter.format(numericValue)
  }

  if (format === 'percent') {
    return `${numberFormatter.format(numericValue * 100)}%`
  }

  if (format === 'percentPoints') {
    return `${numberFormatter.format(numericValue)}%`
  }

  if (format === 'number') {
    return numberFormatter.format(numericValue)
  }

  return String(value)
}

export function userTitle(session: AuthSession) {
  const user = session.user

  if (!user) {
    return ''
  }

  const fullName = `${user.firstName} ${user.lastName}`.trim()
  return fullName || user.email || user.username
}
